import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import PostsSection from './PostsSection';
import PostsSectionContainer from './PostsSection.container';
import PostsSectionContainerBranched from './PostsSection.deviation_gruser.container';

export default withFeatureBranch({
  gruser_posts: PostsSectionContainerBranched(PostsSection),
})(PostsSectionContainer(PostsSection));
